import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Paper from '@material-ui/core/Paper';
import NumberFormat from 'react-number-format';
import { findIndex } from "lodash/array";
import LoadingOverlay from 'react-loading-overlay';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import numeral from "numeral";
import { Box } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
    },
    
    paper: {
        background: "rgb(179,201,60)",
        width:"100%",
        height:"50px",
    },
    formlabelpayment: {
        color:"white",
    }
}));

const BranchPurchasePOPayment = (props) => {
	
    const classes = useStyles();
    const dataInformation = props.location.dataInformation ? props.location.dataInformation : '';
    const itemInformation = props.location.itemInformation ? props.location.itemInformation : '';
    const newShippingCharge = props.location.newShippingCharge ? props.location.newShippingCharge : '';
    const notes = props.location.notes ? props.location.notes : '';
    const [POprice, setPOPrice] = useState(dataInformation.total.replace(",",""));
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [branchCurcode, setBranchCurcode] = useState(get_cookies('curcode'));
    const [userName, setUserName] = useState(get_cookies('username'));
    const [defaultPayment, setDefaultPayment] = useState({id:0,description:"Select Payment",status:0, clearing:"none"});
    const [clearPayment, setClearPayment] = useState({id:0,description:"Select Payment",status:0, clearing:"none"});
    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF
    const [isSaveBtnDisabled, setSaveBtnDisabled] = useState(false);
    //Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
    //Message Box EOF

	//ApiData Component useState SOF
	const [payment_list, loadPaymentDropDown] = useState([]);
	const get_paymentlist = () => {
		//get data for warehouse/location dropdown
		const apiUrl = process.env.REACT_APP_API_URL+'payment_list';
		axios.post(apiUrl).then((res) => {
			loadPaymentDropDown(res.data.payment_list);
		});
    };
    useEffect(() => {
        const newData = {...computedPayment};
        newData['topay_amount'] = POprice;
        newData['shipping_amount'] = newShippingCharge;
        newData['total_balance'] = parseFloat(POprice);
        setComputedPayment({ ...newData });
    }, [POprice]);
	//ApiData Component useState EOF

	//Table Settings
	const [TABLE_DATA, setSelectedPaymentTable] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState({});
    const [computedPayment, setComputedPayment] = useState({});
	const onSelectPayment = () => {
        let newData = [...TABLE_DATA];
        
        const neededKeys = ["payamount", "paymentid"];
        if(neededKeys.every(key => Object.keys(selectedPayment).includes(key))){
            let tempObj;
            if(selectedPayment.paymentname == "Cash"){
                tempObj = {
                    paymentid: selectedPayment.paymentid,
                    paymentname: selectedPayment.paymentname,
                    payamount: selectedPayment.payamount,
                    payref:selectedPayment.payref
                  };
            }else{
                tempObj = {
                    paymentid: selectedPayment.paymentid,
                    paymentname: selectedPayment.paymentname,
                    payamount: selectedPayment.payamount,
                    payref:selectedPayment.payref
                  };
            }

            if(selectedPayment.paymentname == "Cash"){
                if(selectedPayment.payamount == "" || selectedPayment.payamount == 0|| selectedPayment.paymentid == '' || selectedPayment.payref == '' || selectedPayment.payref == null  ){
                    setShowMsgBox(true);
                    setMsg("Please complete all required fields");
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                    }, 3000);
                }else{
                    let amttoadd = Number(computedPayment.total_payment) + Number(selectedPayment.payamount);
                    if(Number(amttoadd) > (Number(computedPayment.topay_amount) + Number(computedPayment.shipping_amount))){
                        setShowMsgBox(true);
                        setMsg("Payment is greater than to the amount to be settle");
                        setMsgType("warning");
                        setTimeout(() => {
                            setShowMsgBox(false);
                        }, 3000);
                    }else{
                        addOrUpdate(newData, tempObj);
                        clear_fields();
                    }
                }

            }else{
                console.log(tempObj);
                 if(selectedPayment.paymentid == "" || selectedPayment.payamount == "" || selectedPayment.payamount == 0 || selectedPayment.payref == "" || selectedPayment.payref == null|| selectedPayment.paymentid == null ){
                    setShowMsgBox(true);
                    setMsg("Please complete all required fields");
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                    }, 3000);
                }else{
                    let amttoadd = Number(computedPayment.total_payment) + Number(selectedPayment.payamount);
               
                    if(Number(amttoadd) > (Number(computedPayment.topay_amount) + Number(computedPayment.shipping_amount))){
                        setShowMsgBox(true);
                        setMsg("Payment is greater than to the amount to be settle");
                        setMsgType("warning");
                        setTimeout(() => {
                            setShowMsgBox(false);
                        }, 3000);
                    }else{
                        addOrUpdate(newData, tempObj);
                        clear_fields();
                    }
                }

            }
        }else{
            setShowMsgBox(true);
            setMsg("Please complete all required fields");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000);
        }
    };

    //Callback function of onSelectPayment
    useEffect(() => {
        computePayment();
        
    }, [TABLE_DATA]);

    const save_branchpo = () => {
        setSaveBtnDisabled(true);
		const form_data = {
            dataInformation: dataInformation,
            itemInformation: itemInformation,
            newShippingCharge: newShippingCharge,
            notes: notes,
            payment_info: TABLE_DATA,
            hqidno: branchIdNo,
            curcode:branchCurcode,
            username:userName
        }
        setSaveBtnDisabled(true);
        setShowOverlay(true);
        setOverlayMsg('Processing Payment...');
        
        if(parseFloat(computedPayment.total_payment) < (parseFloat(computedPayment.topay_amount))){
            setShowMsgBox(true);
            setMsg("Insufficient Payment");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
                setShowOverlay(false);
                setOverlayMsg('');
            }, 3000)
            setSaveBtnDisabled(false);
        }else{
            const formData = new FormData();
            formData.append('form_data', JSON.stringify(form_data));
            const apiUrl = process.env.REACT_APP_API_URL+"savebranchpo";
            axios.post(apiUrl, formData).then((res) => {
                if(res.data.result.success == 1){
                    setShowMsgBox(true);
                    setMsg(res.data.result.message);
                    setMsgType("success");
                    setTimeout(() => {
                        setShowMsgBox(false);
                        setShowOverlay(false);
                        setOverlayMsg('');
                        gobacktoHomepage();
                    }, 3000)
                }else{
                    setShowMsgBox(true);
                    setMsg(res.data.result.message);
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                        setShowOverlay(false);
                        setOverlayMsg('');
                    }, 3000)
                }
            });  
        }
    };

    const addOrUpdate = (array, item) => {
        const i = array.findIndex(_item => _item.paymentid === item.paymentid);
        if (i > -1) array[i].payamount = parseFloat(array[i].payamount) + parseFloat(item.payamount);
        else array.push(item); setSelectedPaymentTable([...array]);
    }

	const onInputChange = (event) => {
     
		const newData = {...selectedPayment};
		newData[event.target.name]= event.target.value;
        setSelectedPayment({ ...newData });
    };
    
    const computePayment = () => {  
        let total_payment = 0.00;
        for (let index = 0; index < TABLE_DATA.length; index++) {
		    total_payment = parseFloat(total_payment) + Number(TABLE_DATA[index].payamount);
        }
        const newData = {...computedPayment};
        const total_balance = parseFloat(computedPayment.topay_amount) - parseFloat(total_payment);
        newData['total_payment']= total_payment;
        newData['total_balance']= total_balance;
        setComputedPayment({ ...newData });
    }

	const refreshTable = () => {
		const newData = [...TABLE_DATA];
		setSelectedPaymentTable([...newData]);
    }

	const TABLE_COLUMNS = [
		{
		  name: 'paymentid',
		  label: 'ID',
		}, {
		  name: 'paymentname',
		  label: 'Payment Type',
		}, {
            name: 'payamount',
            label: 'Amount',
          }, {
		  name: 'payref',
		  label: 'Reference',
		}
	];
	
	const TABLE_OPTION = {
		filterType: 'checkbox',
		selectableRows: 'single',
		selectableRowsHideCheckboxes: true,
		selectableRowsOnClick: true,
        filter: false,
		download: false,  //add this
		print: false,
		viewColumns:false,

		//onRowsDelete: (data) => { console.log(data) }
		onRowsDelete: (data) => { updateSelectedPayment(data.data[0].dataIndex) },
	};

	const updateSelectedPayment = (index) => {
		TABLE_DATA.splice(index, 1);
		refreshTable();
	}
	//Table Settings EOF

	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        isLoggedIn();
        get_paymentlist();
        const newData = {...computedPayment};
        newData['topay_amount'] = POprice;
        newData['total_payment'] = 0;
        newData['shipping_amount'] = newShippingCharge;
        newData['total_balance'] = parseFloat(POprice.replace(",",""));
        setComputedPayment({ ...newData });
    }, []);
    //OnLoad Event/Data Fetching SOF

    //Api Functions SOF
        // Code blocks here
	//Api Request Functions EOF

	const dropDownPaymentList = {
		options: payment_list,
		getOptionLabel: (option) => option.description,
    };
    const numericOnly = (event) => {
        var regex = /^\d*\.?\d*$/g;			
        let x = "";
        if(regex.test(event.target.value)){
            x = event.target.value;
        }else{
            x = "";
        }
        const y = x.replaceAll("-","");
        const newData = {...selectedPayment};
        newData[event.target.name]= y;
        setSelectedPayment({ ...newData });
    }
    
    const clear_fields = () => {
        const newData = {...selectedPayment};
        newData['paymentid']= "";
        newData['paymentname']= "";
        newData['payamount']= "";
        newData['payref']= "";
        setSelectedPayment({ ...newData });
        setDefaultPayment(clearPayment);
    }

    const sales_home =  {
		pathname: "/sales/sales-order"
	}
    const gobacktoHomepage = () => {
        props.history.push(sales_home);
    }
	//FormData
	const [prep_data, setData] = useState({});
    //FormData EOF
	return (
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
                >
                <div className="page-header">
                    <div className="page-icon">
                        <ShoppingCartIcon />
                    </div>
                    <Breadcrumbs aria-label="breadcrumb">
                        <NavLink to="/sales">
                            <h2 className="header-title">Sales</h2>
                        </NavLink>
                        <Typography color="textPrimary">Branch Purchase Order Payment</Typography>
                    </Breadcrumbs>
                </div>
                <div className="page-container">
                    <form noValidate autoComplete="off">
                        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
                        <Grid container spacing={2} className={classes.root}>
                            <Grid item xs={8}>
                                <Card>
                                    <CardContent>
                                        <h4 className={classes.title}>Payment Transaction</h4>
                                        <Grid container spacing={2}>
                                            <Grid xs={12}>
                                                <Autocomplete
                                                    value={defaultPayment}
                                                    options={payment_list}
                                                    getOptionLabel={option => option.description}
                                                    autoComplete
                                                    includeInputInList
                                                    className={classes.autoComplete}
                                                    name="paymentlist"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            margin="normal"
                                                            label="Payment Type"	
                                                            variant="outlined"
                                                            required="true"
                                                        />
                                                    )}
                                                    onChange={(event, newValue) => {
                                                        if (!newValue == "" || !newValue == null){
                                                            setDefaultPayment(newValue);
                                                            const newData = {...selectedPayment};
                                                            newData['paymentid']= JSON.stringify(newValue.id, null, ' ');
                                                            newData['paymentname']= newValue.description;
                                                            setSelectedPayment({ ...newData });
                                                        }
                                                    }}
                                                />
                                                <TextField
                                                    name="payamount"
                                                    label="Amount"
                                                    variant="outlined"
                                                    type="text"
                                                    margin="normal"
                                                    required="true"
                                                    value={selectedPayment.payamount}
                                                    className={classes.field}
                                                    onChange={numericOnly}
                                                />
                                                <TextField
                                                    name="payref"
                                                    label="Reference"
                                                    variant="outlined"
                                                    type="text"
                                                    margin="normal"
                                                    required="true"
                                                    value={selectedPayment.payref}
                                                    className={classes.field}
                                                    onChange={onInputChange}
                                                />
                                            </Grid>
                                            <Grid xs={12} >
                                                <div className={classes.button}>
                                                    <Button variant="outlined" color="primary" onClick={onSelectPayment} className={classes.buttonMarginRigh}>
                                                        Add Payment
                                                    </Button>
                                                </div>	
                                            </Grid>
                                            <Grid item xs={12}>										
                                                <MUIDataTable
                                                    title={
                                                        <div>
                                                            <div className="table-title">
                                                                Payment Details
                                                            </div>
                                                        </div>
                                                    }
                                                    id="table-grid"
                                                    data={TABLE_DATA}
                                                    columns={TABLE_COLUMNS}
                                                    options={TABLE_OPTION}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={4}>
                                <Card>
                                    <CardContent>
                                        <h4 className={classes.title}>Purchase Order Summary</h4>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                    <Box textAlign="right" className={classes.formlabelpayment}>
                                                     <Typography style={{padding:'1px',paddingRight:'3px'}}>Total Amount To Pay:</Typography>
                                                    </Box>
                                                    <Box textAlign="right" className={classes.formlabelpayment} fontWeight="fontWeightBold">
                                                    <Typography style={{paddingRight:'4px'}}>{numeral(computedPayment.topay_amount).format('0,0.00')}</Typography>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                    <Box textAlign="right" className={classes.formlabelpayment}>
                                                         <Typography style={{padding:'1px',paddingRight:'3px'}}>Total Payment:</Typography>
                                                    </Box>
                                                    <Box textAlign="right" className={classes.formlabelpayment} fontWeight="fontWeightBold">
                                                        <Typography style={{paddingRight:'4px'}}>{numeral(computedPayment.total_payment).format('0,0.00')}</Typography>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                     <Box textAlign="right" className={classes.formlabelpayment}>
                                                         <Typography style={{padding:'1px',paddingRight:'3px'}}>Shipping:</Typography>
                                                    </Box>
                                                    <Box textAlign="right" className={classes.formlabelpayment} fontWeight="fontWeightBold">
                                                        <Typography style={{paddingRight:'4px'}}>{numeral(computedPayment.shipping_amount).format('0,0.00')}</Typography>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" className={classes.paper}>
                                                    <Box textAlign="right" className={classes.formlabelpayment}>
                                                         <Typography style={{padding:'1px',paddingRight:'3px'}}>Total Balance:</Typography>
                                                    </Box>
                                                    <Box textAlign="right" className={classes.formlabelpayment} fontWeight="fontWeightBold">
                                                        <Typography style={{paddingRight:'4px'}}>{numeral(computedPayment.total_balance).format('0,0.00')}</Typography>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs="12" className={classes.buttonContainer}>
                                <Button 
                                    variant="contained" 
                                    color="primary"
                                    disabled={isSaveBtnDisabled}
                                    onClick={save_branchpo}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </LoadingOverlay>
		</div>
	);
};

export default BranchPurchasePOPayment;
